import notify from 'devextreme/ui/notify'
import { useDispatch } from 'react-redux'
import {
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Nav
} from 'reactstrap'
import { Link } from 'react-router-dom'
import { refreshSession } from '../../../redux/slices/sessionSlice'
import NotificationIcon from '../../NotificationIcon/NotificationIcon'

const UserMenu = (props) => {
  const dispatch = useDispatch()

  const handleReloadPermissions = async () => {
    try {
      dispatch(refreshSession())
      notify({
        message: 'User permissions updated',
        height: 52,
        maxWidth: 600,
        minWidth: 150,
        type: 'success',
        displayTime: 1500,
        animation: {
          show: {
            type: 'fade',
            duration: 400,
            from: 0,
            to: 1
          },
          hide: { type: 'fade', duration: 300, from: 1, to: 0 }
        },
        position: 'top center',
        direction: 'down-push'
      })
    } catch (err) {
      notify({
        message: 'Error reloading permissions',
        height: 52,
        maxWidth: 600,
        minWidth: 150,
        type: 'error',
        displayTime: 1500,
        animation: {
          show: {
            type: 'fade',
            duration: 400,
            from: 0,
            to: 1
          },
          hide: { type: 'fade', duration: 300, from: 1, to: 0 }
        },
        position: 'top center',
        direction: 'down-push'
      })
    }
  }

  return (
    <UncontrolledDropdown nav inNavbar>
      <DropdownToggle nav caret className="glyphicons">
        <NotificationIcon icon="crown" top="top" />
        <p className="username-p nav-link-p">
          {props.firstName} {props.lastName}
        </p>
      </DropdownToggle>
      <Nav>
        <DropdownMenu className="submenu">
          <DropdownItem>
            <a
              href="/ui/#!/account"
              className="glyphicons glyphicons-cogwheels"
            >
              My Account
            </a>
          </DropdownItem>
          <DropdownItem>
            <a href="/ui/#!/account/notifications">
              <NotificationIcon icon="alarm" top="bottom" />
              Notifications
            </a>
          </DropdownItem>
          <DropdownItem>
            <a
              href="/ui/#!/account/downloads"
              className="glyphicons glyphicons-cloud-download"
            >
              Downloads
            </a>
          </DropdownItem>
          <DropdownItem>
            <a
              href="/ui/#!/account/passwordChange"
              className="glyphicons glyphicons-user-key"
            >
              Change Password
            </a>
          </DropdownItem>
          <DropdownItem>
            <Link
              id="reloadPermissions"
              onClick={handleReloadPermissions}
              to="#"
              className="glyphicons glyphicons-rotation-lock"
            >
              Reload Permissions
            </Link>
          </DropdownItem>
          <DropdownItem>
            <Link
              id="signOut"
              className="glyphicons glyphicons-exit"
              to="/ui2/logout"
            >
              Logout
            </Link>
          </DropdownItem>
        </DropdownMenu>
      </Nav>
    </UncontrolledDropdown>
  )
}

export default UserMenu
